import { useModal } from "@components/Modal";
import { useCallback, useState } from "react";
import { useTranslation } from "react-i18next";
import { PasswordInput } from "../../../components/PasswordInput";

export function useEnrollCourseModal(onEnroll: (password: string) => void) {
  const { Modal, openModal } = useModal();
  const { t } = useTranslation("coursePage");

  function EnrollCourseModal() {
    const [password, setPassword] = useState("");

    const handleConfirm = useCallback(() => {
      onEnroll(password);
    }, [onEnroll, password]);

    return (
      <Modal
        title={t("enrollCourseModalTitle")}
        onConfirm={handleConfirm}
        onConfirmLabel={t("enroll")}
      >
        <div className="mt-md flex flex-col justify-center">
          <PasswordInput
            onChange={(e) => setPassword(e.target.value)}
            minLength={1}
            value={password}
          />
        </div>
      </Modal>
    );
  }

  return {
    EnrollCourseModal,
    openEnrollModal: openModal,
  };
}
